import { cartLineCardCondensedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
import { css } from "styled-components";

cartLineCardCondensedStyles.productPrice = {
    priceLabelText: {
        css: css`
            display: none;
        `,
    },
};

cartLineCardCondensedStyles.quantity = {
    editableQuantityTextField: {
        labelProps: {
            css: css`
                display: none;
            `,
        },
    },
};

cartLineCardCondensedStyles.productImageGridItem = {
    width: 0,
    css: css`
        display: none;
    `,
};

cartLineCardCondensedStyles.productBrandAndDescriptionGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

cartLineCardCondensedStyles.productPriceAndQuantityGridItem = {
    width: [12, 12, 12, 6, 6],
};

cartLineCardCondensedStyles.cartLineInfoGridItem = {
    width: [10, 10, 10, 11, 11],
};

cartLineCardCondensedStyles.productPriceAndAvailabilityGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
        justify-content: center;
    `,
};
